export const POLICIES_LINK = 'https://branch.io/policies';

export const COOKIE_DISPLAY_NAME = 'Cookie Policy';

export const TERMS_CONSENT_DB_FIELD = 'terms_consent_date';

export const COOKIE_ACCEPT_DB_FIELD = 'cookie_accept_date';
export const COOKIE_DECLINE_DB_FIELD = 'cookie_decline_date';
